import { render } from "./AfgerondTeamWinnaar.vue?vue&type=template&id=443e10ba&scoped=true"
import script from "./AfgerondTeamWinnaar.vue?vue&type=script&lang=js"
export * from "./AfgerondTeamWinnaar.vue?vue&type=script&lang=js"

import "./AfgerondTeamWinnaar.vue?vue&type=style&index=0&id=443e10ba&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443e10ba"]])

export default __exports__